import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'integrations';

export const actionTypes = {
  INTEGRATIONS_DISCONNECT: `${FEATURE_NAME}/INTEGRATIONS_DISCONNECT`,
  SAVE_NEW_INTEGRATION: `${FEATURE_NAME}/SAVE_NEW_INTEGRATION`,
  GET_ORGANIZATION: `${FEATURE_NAME}/GET_ORGANIZATION`
} satisfies ActionTypes<typeof FEATURE_NAME>;